var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDropdown(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2002 10.2002C10.6144 10.2002 10.9502 10.536 10.9502 10.9502V16.4502C10.9502 16.8644 10.6144 17.2002 10.2002 17.2002C9.78598 17.2002 9.4502 16.8644 9.4502 16.4502V10.9502C9.4502 10.536 9.78598 10.2002 10.2002 10.2002Z",
    fill: "#676879"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16987 14.2197C7.46276 13.9268 7.93763 13.9268 8.23053 14.2197L10.2002 16.1893L12.1699 14.2197C12.4628 13.9268 12.9376 13.9268 13.2305 14.2197C13.5234 14.5126 13.5234 14.9874 13.2305 15.2803L10.7305 17.7803C10.4376 18.0732 9.96276 18.0732 9.66987 17.7803L7.16987 15.2803C6.87697 14.9874 6.87697 14.5126 7.16987 14.2197Z",
    fill: "#676879"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.75C2 2.7835 2.7835 2 3.75 2H16.25C17.2165 2 18 2.7835 18 3.75V6.75C18 7.7165 17.2165 8.5 16.25 8.5H3.75C2.7835 8.5 2 7.7165 2 6.75V3.75ZM3.75 3.5C3.61193 3.5 3.5 3.61193 3.5 3.75V6.75C3.5 6.88807 3.61193 7 3.75 7H16.25C16.3881 7 16.5 6.88807 16.5 6.75V3.75C16.5 3.61193 16.3881 3.5 16.25 3.5H3.75Z",
    fill: "#676879"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.36416f4d.svg";
export { ForwardRef as ReactComponent };